export default __webpack_public_path__ + "static/media/alien-worlds-logo.e4ab2f0e.svg";